import { HttpStatusCode } from '@angular/common/http';

export interface ErrorDetails {
  message: string;
  image: string;
}

export const ERRORS: Partial<Record<HttpStatusCode, ErrorDetails>> = {
  [HttpStatusCode.Unauthorized]: {
    message: "Vous n'êtes pas autorisé à accéder à cette ressource.",
    image: 'secure_files.png',
  },
  [HttpStatusCode.Forbidden]: {
    message: "Vous n'avez pas les droits pour accéder à cette page.",
    image: 'secure_files.png',
  },
  [HttpStatusCode.NotFound]: {
    message: "Désolé, mais la page demandée n'a pas été trouvée !",
    image: 'page_not_found.png',
  },
  [HttpStatusCode.InternalServerError]: {
    message: 'Une erreur interne du serveur est survenue.',
    image: 'bug_fixing.png',
  },
  [HttpStatusCode.ServiceUnavailable]: {
    message: 'Le service est actuellement indisponible en raison de la surcharge du serveur.',
    image: 'bug_fixing.png',
  },
  [HttpStatusCode.GatewayTimeout]: {
    message: "Délai d'attente dépassé. Veuillez réessayer plus tard.",
    image: 'bug_fixing.png',
  },
};
